import makeUploadRequest from "../api/makeUploadRequest.live";
import { RequstMethods } from "../api/requestMethode";
import url from "../api/urls";

export class FileUploadService {
    static async fileUplaod(payload: any) {
        return await makeUploadRequest(url.liveExam.uploadFile, RequstMethods.POST, payload)
    }
}